import React from 'react'
import { Column, Flex, Show } from '.'
import { classNameBuilder } from '@/helpers'

export type InputWrapperDirection = 'column' | 'row'

export interface InputWrapperProps {
  label?: string
  error?: string
  required?: boolean
  disabled?: boolean
  children?: React.ReactNode
  className?: string
  labelStyle?: string
  labelFor?: string
  direction?: InputWrapperDirection
}

export const InputWrapper: React.FC<InputWrapperProps> = (props) => {
  return (
    <Flex
      className={classNameBuilder(
        props.direction === 'row'
          ? '!flex-row !items-center !gap-xs'
          : 'flex-col items-start',
        props.className
      )}
    >
      <Show when={!!props.label}>
        <label
          htmlFor={props.labelFor}
          className={classNameBuilder(
            'text-sm font-medium !text-[#282828]',
            props.direction !== 'row' && 'mb-2',
            'after:ml-0.5 after:text-danger-300 after:content-["*"]',
            !props.required && 'after:hidden',
            props.error ? 'text-red' : 'text-gray-400',
            props.labelStyle
          )}
        >
          {props.label}
        </label>
      </Show>
      <Column
        className={classNameBuilder(props.direction !== 'row' && 'w-full')}
      >
        {props.children}
        <span className="h-0 text-xs leading-5 text-red">
          {props.error ? '*' + props.error : null}
        </span>
      </Column>
    </Flex>
  )
}

export default InputWrapper
